import { calc, formatNumber } from '../../helpers/numbers'

export const formatNumberToShort = (number, decimalPlaces = 0) => {
  if (number >= 1000000) {
    // Millions: Always 2 decimal places, round to 0.01m
    return `${calc(number).div(1000000).toFixed(2)}m`
  } else if (number >= 1000) {
    // Thousands: Always 0 decimals, round to nearest 1k
    return `${calc(number).div(1000).toFixed(0)}k`
  } else {
    return formatNumber(number, { min: decimalPlaces, max: decimalPlaces })
  }
}
